export default __webpack_public_path__ + "static/media/invalid_code.e56ca4cb.png";